'use client';

import { c } from 'ui-components';

type SkeletonProps = {
  className?: string;
};

export const Skeleton = ({ className }: SkeletonProps) => {
  return <div className={c('rounded bg-surface-muted', className)} />;
};
